export const DEFAULT_LOCALE = 'en-US'

export const SUPPORTED_LOCALES = ['en-US', 'lt-LT'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]
